module.exports = __webpack_public_path__ + "img/avatar.77d9312a.svg";